<h1 mat-dialog-title> Observaciones historicas</h1> <br />
<form #observacionHistoricoForm=ngForm>
    <div class = "table-responsive" style="max-height: 300px; overflow-y: auto;">
        <table class = "table">
            <thead style = "background-color: #0f69b4;color:white;">
                <tr>
                    <th scope = "col"> Fecha </th>
                    <th scope = "col"> Observacion </th>
                    <th scope = "col"> Ejecutivo </th>
                </tr>
            </thead>
           <tbody>
                <tr class = "tablaPostulaciones" *ngFor = "let obs of observaciones ; let i = index">               
                    <td> {{obs.fecha}} </td>
                    <td> {{obs.observacion}} </td>
                    <td> {{obs.nombreEjecutivo}} </td>
                </tr>
            </tbody>
        </table> <br/>
    </div>  
    <br />
</form>
<mat-dialog-actions>
    <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
        <i class="fa fa-trash"> </i> Salir
    </button>
</mat-dialog-actions>

<br />